import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Drawer, Form, Input, Select } from "antd";
import PropTypes from "prop-types";

import { Modals, Status } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";
import { ObjectNumbersToEnglish } from "scripts/helpers";

const Component = ({ data = {}, onUpdate }) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { submitting, visible } = state;
	const { slug } = data;
	const { hash } = useLocation();
	const navigate = useNavigate();
	const [form] = Form.useForm();

	const handleClose = () => {
		navigate(-1);
	};

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));

				values = ObjectNumbersToEnglish(values);

				API.job
					.status(slug, values)
					.then(() => {
						onUpdate(null, true);
						handleClose();
					})
					.catch(() => {
						setState((prevState) => ({
							...prevState,
							submitting: false,
						}));
					});
			});
		}
	};

	const componentDidUpdate = () => {
		switch (hash) {
			case `#${Modals.STATUS}`: {
				setState((prevState) => ({ ...prevState, visible: true }));

				break;
			}

			default: {
				if (visible) form.resetFields();

				setState(initialState);

				break;
			}
		}
	};

	useEffect(componentDidUpdate, [hash]);

	const footer = (
		<>
			<Button
				type="primary"
				onClick={handleSubmit}
				loading={submitting}
			>
				{Resources.confirm}
			</Button>
			<Button
				onClick={() => handleClose()}
				loading={submitting}
			>
				{Resources.cancel}
			</Button>
		</>
	);

	return (
		<Drawer
			className="sp-form-drawer"
			footer={footer}
			onClose={() => handleClose()}
			title={`${Resources.change}  ${Resources.status}`}
			maskClosable={false}
			open={visible}
			width={414}
		>
			<Form
				layout="vertical"
				form={form}
			>
				<Form.Item
					name="status"
					label={Resources.status}
					rules={Rules.required}
				>
					<Select
						placeholder={Resources.job}
						options={[
							{ label: Resources.approved, value: Status.job.approved },
							{ label: Resources.neutral, value: Status.job.neutral },
							{ label: Resources.pending, value: Status.job.pending },
							{ label: Resources.rejected, value: Status.job.rejected },
							{ label: Resources.suspended, value: Status.job.suspended },
						]}
						showSearch
					/>
				</Form.Item>
				<Form.Item
					shouldUpdate={(prevValues, curValues) =>
						prevValues.status !== curValues.status
					}
					noStyle
				>
					{({ getFieldValue }) => {
						const status = getFieldValue("status");

						return (
							<>
								{status === Status.job.rejected ? (
									<Form.Item
										name="rejectReason"
										label={`${Resources.reason} ${Resources.reject}`}
										rules={Rules.required}
									>
										<Input.TextArea rows={4} />
									</Form.Item>
								) : null}
								{status === Status.job.suspended ? (
									<Form.Item
										name="suspendReason"
										label={`${Resources.reason} ${Resources.suspend}`}
										rules={Rules.required}
									>
										<Input.TextArea rows={4} />
									</Form.Item>
								) : null}
							</>
						);
					}}
				</Form.Item>
			</Form>
		</Drawer>
	);
};

Component.propTypes = {
	data: PropTypes.object,
	onUpdate: PropTypes.func.isRequired,
};

export default Component;
